import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4c07094d&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07094d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c07094d')) {
      api.createRecord('4c07094d', component.options)
    } else {
      api.reload('4c07094d', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4c07094d&scoped=true", function () {
      api.rerender('4c07094d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/components/setting-lottery/main.vue"
export default component.exports